import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/2_blue/2_blue"
 * Contains 1 texture(s)
 */
export class Tablet2BlueAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/2_blue/2_blue';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '2_blue.png'
    ] as const;
}
